<script setup lang="ts" generic="T">
interface Props {
  list: T[]
  /** 滚动时间 */
  animationTime: string
  /** 方向 */
  direction: 'horizontal' | 'vertical'
  /** 动画方向 */
  animationDirection?: 'normal' | 'reverse'
}

const props = withDefaults(defineProps<Props>(), {
  animationDirection: 'normal',
})

const { isRtl } = useLayout()
const offset = computed(() => isRtl.value ? '50%' : '-50%')
// 看要copy几次
const transform = computed(() => props.direction === 'vertical' ? `translate3d(0, -50%, 0)` : `translate3d(${offset.value}, 0, 0)`)
</script>

<template>
  <section class="infinite-loop flex rtl:animate-duration-[reverse]" :class="direction === 'vertical' ? 'flex-col' : 'flex-row'">
    <template v-for="(item, index) in props.list" :key="index">
      <slot v-bind="{ item, index }" />
    </template>
    <!-- 后半部分仅在客户端渲染 -->
    <ClientOnly>
      <template v-for="(item, index) in props.list" :key="index + props.list.length">
        <slot v-bind="{ item, index }" />
      </template>
    </ClientOnly>
  </section>
</template>

<style lang="scss" scoped>
@-webkit-keyframes rowup {
  0% {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
  100% {
    -webkit-transform: v-bind(transform);
    transform: v-bind(transform);
  }
}
@keyframes rowup {
  0% {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
  100% {
    -webkit-transform: v-bind(transform);
    transform: v-bind(transform);
  }
}
.infinite-loop {
  animation: rowup linear infinite;
  animation-duration: v-bind('props.animationTime');
  &:hover {
    -webkit-animation-play-state: paused;
    animation-play-state: paused;
  }
}
</style>
